export const CONFIG = {
  appSiteKey: process.env.REACT_APP_SITE_KEY,
  appApiDomain: process.env.REACT_APP_API_DOMAIN,
  appSiteDomain: process.env.REACT_APP_DOMAIN,
};
